import { k as e, l as r, m as E, n as L } from "./variables-Cd7m-943.js";
var n = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(E, 10)] = "LARGE", a[a.XLARGE = parseInt(L, 10)] = "XLARGE", a))(n || {});
export {
  n as B
};
